import { useState } from "react"
import { ChevronDownIcon as ExpandIcon } from "@heroicons/react/24/outline"
import { twMerge } from "tailwind-merge"
import VariantReader from "../../VariantReader"
import defaultVariants from "../variants"

export default function GroupRenderFoldable({
  contentType,
  namedGroups,
  ungroupedGroup,
  renderGroupFields,
  variant = "default",
  fieldSearchData,
  renderSearchResults,
}) {
  let variants = VariantReader.useVariant({ componentName: "CMS", variant })
  if (Object.keys(variants).length === 0) {
    variants = defaultVariants[variant] || defaultVariants.default
  }
  if (!variants.groups) {
    variants = { ...variants, groups: defaultVariants.default.groups }
  }

  const [expandedGroups, setExpandedGroups] = useState(() => {
    const state = {}
    contentType?.groups?.forEach((g) => {
      state[g.id] = g.expanded || false
    })
    return state
  })

  const toggleGroup = (groupId) =>
    setExpandedGroups((prev) => ({ ...prev, [groupId]: !prev[groupId] }))

  if (fieldSearchData?.hasActiveSearch) {
    return renderSearchResults()
  }

  const renderFoldableGroup = (group) => {
    if (!group) return null
    if (group.visible === false) return null

    const groupVariant = group.render?.variant
      ? variants.groups[group.render.variant]
      : variants.groups?.default ?? defaultVariants.groups.default

    if (group.hidePanel) {
      return (
        <div key={group.id || "__ungrouped__"} className="flex flex-row flex-wrap">
          {renderGroupFields(group)}
        </div>
      )
    }

    const isExpanded = expandedGroups[group.id] || !group.id

    return (
      <div key={group.id || "__ungrouped__"} className={groupVariant.root}>
        <button className={groupVariant.panel} onClick={() => toggleGroup(group.id)}>
          <div className={groupVariant.panel_content}>
            <h3 className={groupVariant.panel_title}>{group.label}</h3>
            {group.description && (
              <p className={groupVariant.panel_description}>{group.description}</p>
            )}
          </div>
          <span
            className={twMerge(
              groupVariant.panel_arrow,
              `transform ${isExpanded ? "rotate-180" : ""}`
            )}
          >
            <ExpandIcon className={groupVariant.panel_expand_icon} />
          </span>
        </button>
        {isExpanded && (
          <div className={groupVariant.content}>{renderGroupFields(group)}</div>
        )}
      </div>
    )
  }

  return (
    <div>
      {namedGroups.map(renderFoldableGroup)}
      {ungroupedGroup._hasContent && renderFoldableGroup(ungroupedGroup)}
    </div>
  )
}
